import { render, staticRenderFns } from "./zsbAcvitityFoot.vue?vue&type=template&id=91340dca&scoped=true&"
import script from "./zsbAcvitityFoot.vue?vue&type=script&lang=js&"
export * from "./zsbAcvitityFoot.vue?vue&type=script&lang=js&"
import style0 from "./zsbAcvitityFoot.vue?vue&type=style&index=0&id=91340dca&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91340dca",
  null
  
)

export default component.exports